import { isEeaCountry } from '@/lists/countriesToRegion';
import { Country } from '@/types';

/**
 * EU MDR bars "Treat" as a verb for EU/EEA and UK clinicians.
 *
 * Gate on `User.country`, not server region (`getRegion` / `isUSMarket`).
 * A missing country fails closed: the compliant copy is Explore plus the
 * retrieval-oriented suggestion variants. Switzerland is outside the EEA
 * and is not restricted here. Japan is handled separately (the Treat verb
 * is hidden entirely).
 */
export const isTreatWordingRestricted = (country: string | null | undefined): boolean => {
  if (!country) return true;
  return isEeaCountry(country) || country === (Country.UNITED_KINGDOM as string);
};
